import * as actionTypes from '../../actionTypes';
import { migrateSkills } from '../../helpers/applicants';

// initial state
export const initialState = {};


export default function applicantProfileReducer(state = initialState, {type, ...action}) {
  switch (type) {

    case actionTypes.UPDATE_APPLICANT :
      const profile = migrateSkills(action.profile);
      return {...state, ...profile};

    case actionTypes.CLEAR_APPLICANT :
    case actionTypes.LOG_OUT :
      return {};

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./shared/redux/reducers/applicantProfile/index.js